module.exports = __webpack_public_path__ + "assets/img/zhuanjia_en.d27e5756.png";